const NotFoundPage = () => {
    return (
        <div>

        </div>
    )
}

export default NotFoundPage
